import { observable, computed, action } from "mobx";

import VideoModel from "./VideoModel";
import VideoService from "../service/VideoService";
import FirestoreService from "../service/FirestoreService";

export default class VideoListModel {
    @observable _videos = [];

    constructor() {        
        VideoService.getAllVideos((snapshot, collectionRef) => {
            if (!snapshot) {
                return;
            } else {
                this._videos = [];
                snapshot.forEach(doc => {
                    //console.log("videos count : %s, doc %s:%o", this.videos.length, doc.id, doc.data());
                    var docData = doc.data();                                                          

                    // Anything that expires should not be shown except for testing
                    if ((window !== undefined && window.location.search.match('showall') === null) && docData.expiry < new Date())
                        return;

                    var clusterArray = FirestoreService.ObjectToArray(docData.clusters);                    

                    var video = new VideoModel(doc.id, docData.name, docData.url, clusterArray, docData.expirydate.toDate(), docData.releasedate.toDate(), docData.enabled, docData.manageronly);                    

                    this._videos.push(video);
                });
            }
        });
    }

    @computed
    get videos() {
        return this._videos;
    }

    @computed
    get totalVideoCount() {
        return this._videos.length;
    }        

    @action
    getVideo(id) {
        return this.videos.filter(video => video.id === id);
    }

    @action
    addVideo(video, callback) {

        VideoService.createVideo(video, (p) => {
            //console.log("add new video:" + p.name);
            //this.videos.push(p);

            if (typeof callback === "function")
                callback(p);
        });
    }

    @action
    updateVideo(video, changeDateModified) {
        VideoService.updateVideo(video, changeDateModified);
    }

    @action
    deleteVideo(video) {
        VideoService.deleteVideo(video);
    }
}


// WEBPACK FOOTER //
// ./src/models/VideoListModel.js